import { getApiUrl } from 'client/modules/Url';
import { DateRange } from '../../../Date/types';
import {
  NetworkGeoLocationPlaysParameters,
  NetworkGeoLocationPlaysResponse,
} from './fetchNetworkGeoLocationPlays';

type WithoutDateRangeParams<T> = Partial<Omit<T, keyof DateRange>>;

export type StationGeoLocationPlaysParameters = Omit<
  WithoutDateRangeParams<NetworkGeoLocationPlaysParameters>,
  'userId'
>;

export type StationGeoLocationPlaysResponse = Omit<
  NetworkGeoLocationPlaysResponse,
  'podcastNetwork' | 'data'
> & {
  data: {
    rows: [string, number][];
    columnHeaders: [
      { name: 'Geo'; type: 'string' },
      { name: 'Percent of Plays'; type: 'number' }
    ];
    assets: {
      flagUrlByGeo: { [key: string]: string };
    };
  };
};

export async function fetchStationGeoLocationPlays({
  webStationId,
  resultGeo,
  geo1,
  geo2,
  geo3,
  geo4,
}: StationGeoLocationPlaysParameters): Promise<StationGeoLocationPlaysResponse> {
  try {
    const resp = await fetch(
      getStationGeoLocationPlaysUrl({
        webStationId,
        resultGeo,
        geo1,
        geo2,
        geo3,
        geo4,
      }),
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );

    if (resp.ok) {
      return await resp.json();
    }

    throw new Error(`Cold not fetch station's plays by geo location`);
  } catch (err) {
    throw new Error(err.message);
  }
}

export function getStationGeoLocationPlaysUrl({
  webStationId,
  resultGeo,
  geo1,
  geo2,
  geo3,
  geo4,
  csvFilename,
  includeLimit = true,
  startDateRange,
  endDateRange,
}: StationGeoLocationPlaysParameters & {
  csvFilename?: string;
  includeLimit?: boolean;
  startDateRange?: Date;
  endDateRange?: Date;
}) {
  const baseParams = {
    resultGeo,
    geo1,
    geo2,
    geo3,
    geo4,
    csvFilename,
    startDateRange,
    endDateRange,
  };
  const queryParameters = includeLimit
    ? {
        limit: 200,
        ...baseParams,
      }
    : baseParams;
  return getApiUrl({
    path: `analytics/station/webStationId:${webStationId}/playsByGeo`,
    queryParameters,
  });
}
